import React, { useEffect, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import NumberInputFormControl from "../../../shared/form-controls/NumberInputFormControl";
import TextInputFormControl from "../../../shared/form-controls/TextInputFormControl";

import "./AdditionalLocationForm.css";

function AdditionalLocationForm({ formData, submitForm }) {
  const history = useHistory();

  const { handleSubmit, control, reset } = useForm({
    defaultValues: useMemo(() => formData, [formData]),
  });
  useEffect(() => {
    reset(formData);
  }, [formData]);

  return (
    <form onSubmit={handleSubmit(submitForm)} novalidate className="w-100">
      <div className="container" style={{ textAlign: "initial" }}>
        <div className="row justify-content-md-center">
          <div className="col-md">
            <Controller
              control={control}
              name="method"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <TextInputFormControl
                  label="Method"
                  placeholder="Method"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
            <Controller
              control={control}
              name="additionalRunChargeNet"
              rules={{ required: true }}
              render={({
                field: { onChange, value, name },
                fieldState: { error },
              }) => (
                <NumberInputFormControl
                  label="Additional Run Net Charge"
                  placeholder="Additional Run Net Charge"
                  required
                  name={name}
                  value={value}
                  onChange={onChange}
                  error={error}
                />
              )}
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="d-flex justify-content-center">
        <span
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </span>
        <button type="submit" className="btn btn-sm btn-success">
          Save
        </button>
      </div>
    </form>
  );
}

export default AdditionalLocationForm;
